import edit from './edit.ejs'
import view from './view.ejs'

export default {
  treeView: {
    form: view
  },
  treeEdit: {
    form: edit
  }
}
